export const queryKeys = {
  MAIN_ORGANIZATION_PROBLEMS_VIEW: "main-organization-problems-view",
  MAIN_ORGANIZATION_DETAILED_PROBLEM: "main-organization-detailed-problem",
  MAIN_ORGANIZATION_EMPLOYEES_SELECT: "main-organization-employees-select",
  MAIN_ORGANIZATION_ORGANIZATION_SELECT: "main-organization-organizatino-select",
}